/* nt-popular-size-cap.js — hide "popular size" options that exceed the product's
   own custom-size cap.

   Why JS and not Liquid: the popular <option> list is rendered from
   product.variants in FOUR different snippets (__uploadBoxBlock,
   __multiuploadSnippets ×2 sites, portal-multiupload, bySizeNew) — 12 render
   points — and bySizeNew.liquid then REBUILDS the <select> from the variant
   radios at runtime. Filtering server-side would need the same guard copied 12
   times and would still be undone by the rebuild. One DOM pass covers every
   render site and survives the rebuild.

   The cap is read from the page's own custom-size inputs (min/max, in inches,
   driven by the block's setMinWidth / maxSize settings) rather than hardcoded,
   so it tracks the limit automatically: raise the cap in the theme editor and
   the matching popular sizes come back. UV = 21cm, DTF by-size = 35cm.

   No-ops safely when the inputs are absent — e.g. the by-size-v4 (BSV4) engine
   renders no .widthHeight__value inputs, so DTF PDPs are untouched.

   Titles are the UK cm-named carrier variants ("23cm x 23cm"); inch-named
   options ('4" x 4"') are left alone since this store's by-size products are
   cm-named. */
(function () {
  var IN2CM = 2.54;
  var TOL = 0.05; // absorbs float drift: 8.2677in x 2.54 = 20.99998, not 21

  /* Cap comes from window.NT_SIZE_CAP_IN, emitted by bySizeNew.liquid from the
     block's maxSize / maxSizeHeight settings (inches). Deliberately NOT read off
     the size inputs' max attribute: the theme blanks min/max at runtime because
     it uses [min=""][max=""] as a selector marker, so the values are gone before
     any script can read them. */
  function capCm() {
    var c = window.NT_SIZE_CAP_IN;
    if (!c) return null;
    var maxW = parseFloat(c.w);
    var maxH = parseFloat(c.h);
    if (!isFinite(maxW) || maxW <= 0) return null;
    if (!isFinite(maxH) || maxH <= 0) maxH = maxW;
    return { w: maxW * IN2CM + TOL, h: maxH * IN2CM + TOL };
  }

  // "23cm x 23cm - Medium Sign / Door Decal" -> {w:23, h:23}
  function dimsOf(text) {
    var m = String(text || '').match(/([\d.]+)\s*cm\s*[x×]\s*([\d.]+)\s*cm/i);
    if (!m) return null;
    var w = parseFloat(m[1]), h = parseFloat(m[2]);
    return isFinite(w) && isFinite(h) ? { w: w, h: h } : null;
  }

  function sweep() {
    var cap = capCm();
    if (!cap) return;
    var opts = document.querySelectorAll('.customTabelPopup__sizes__popularSelect option, select.popularSelect option');
    for (var i = 0; i < opts.length; i++) {
      var o = opts[i];
      if (o.getAttribute('data-nt-cap') === '1') continue;
      // The label is relabelled in place by bySize_popular.js after a smart-fit,
      // so judge by the ORIGINAL variant size (the value attr), falling back to
      // the visible text on first paint.
      var d = dimsOf(o.getAttribute('value')) || dimsOf(o.textContent);
      if (!d) continue;
      if (d.w > cap.w || d.h > cap.h) {
        o.setAttribute('data-nt-cap', '1');
        if (o.selected && o.parentNode) o.parentNode.selectedIndex = 0;
        o.parentNode && o.parentNode.removeChild(o);
        i--; // live NodeList is static here, but keep index honest if not
      }
    }
  }

  function start() {
    sweep();
    // The select is repopulated from the variant radios after load, and the
    // picker markup mounts late — re-sweep on any DOM change, debounced.
    var t = null;
    new MutationObserver(function () {
      if (t) return;
      t = setTimeout(function () { t = null; sweep(); }, 60);
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
